export enum HeroBannerType {
  Default = 'default',
  WithContent = 'withContent',
}
